import { inject, Injectable } from '@angular/core';
import { ConfirmationService, Confirmation } from '@abp/ng.theme.shared';
import { ABP, ListService, PagedResultDto } from '@abp/ng.core';
import { filter, switchMap } from 'rxjs/operators';
import type {
  GetGalileuCredentialsInput,
  GalileuCredentialWithNavigationPropertiesDto,
} from '../../../proxy/galileu-credentials/models';
import { GalileuCredentialService } from '../../../proxy/galileu-credentials/galileu-credential.service';

@Injectable()
export class GalileuCredentialViewService {
  protected readonly proxyService = inject(GalileuCredentialService);
  protected readonly confirmationService = inject(ConfirmationService);
  protected readonly list = inject(ListService);

  data: PagedResultDto<GalileuCredentialWithNavigationPropertiesDto> = {
    items: [],
    totalCount: 0,
  };

  filters = {} as GetGalileuCredentialsInput;

  delete(record: GalileuCredentialWithNavigationPropertiesDto) {
    this.confirmationService
      .warn('::DeleteConfirmationMessage', '::AreYouSure', { messageLocalizationParams: [] })
      .pipe(
        filter(status => status === Confirmation.Status.confirm),
        switchMap(() => this.proxyService.delete(record.galileuCredential.id)),
      )
      .subscribe(this.list.get);
  }

  hookToQuery() {
    const getData = (query: ABP.PageQueryParams) =>
      this.proxyService.getList({
        ...query,
        ...this.filters,
        filterText: query.filter,
      });

    const setData = (list: PagedResultDto<GalileuCredentialWithNavigationPropertiesDto>) => {
      this.data = list;
    };

    this.list.hookToQuery(getData).subscribe(setData);
  }

  clearFilters() {
    this.filters = {} as GetGalileuCredentialsInput;
    this.list.get();
  }
}
